export default __webpack_public_path__ + "static/media/withlogo.005.07514aae.jpeg";